export default __webpack_public_path__ + "static/media/640_store03-fr-web.8b46167c.png";